import { NgModule } from '@angular/core';
import { AsmComponentsModule } from '@spartacus/asm/components';
import { AsmOccModule } from '@spartacus/asm/occ';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CartPageEventModule } from '@spartacus/cart/base/core';
import { WishListModule } from '@spartacus/cart/wish-list';
import {
  AnonymousConsentsModule,
  AuthModule,
  ConfigModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  ProductModule,
  ProductOccModule,
  provideConfig,
  provideFeatureToggles,
  UserModule,
  UserOccModule
} from '@spartacus/core';
import { SmartEditModule } from '@spartacus/smartedit';
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  JsonLdBuilderModule,
  LinkModule,
  NavigationEventModule,
  NavigationModule,
  PDFModule,
  ProductDetailsPageModule,
  ProductListingPageModule,
  ProductListModule,
  ProductPageEventModule,
  SiteContextSelectorModule,
  TabParagraphContainerModule,
  UserComponentModule,
  VideoModule,
} from '@spartacus/storefront';

import { PersonalizationModule } from '@spartacus/tracking/personalization';
import { KnBrCustomerLibsModule } from 'src/customer-libs/kn-br-customer-libs.module';
import { environment } from 'src/environments/environment';
import { KnBrFeaturesLibsModule } from 'src/feature-libs/kn-br-feature-libs.module';
import { KnBrOrderOccModule } from 'src/feature-libs/kn-br-order/occ/kn-br-occ-order.module';
import { KnBrProductOccModule } from 'src/feature-libs/kn-br-product/occ/kn-br-occ-product.module';
import { KnBrUserAccountModule } from 'src/feature-libs/kn-br-user/kn-br-account/kn-br-account.module';
import { KnBrUserProfileModule } from 'src/feature-libs/kn-br-user/kn-br-profile/kn-br-profile.module';
import { KnBrStoreModule } from 'src/store/kn-br-store.module';
import { KnBrCommonModule } from '../common/kn-br-common.module';
import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module';
import { ImportExportFeatureModule } from './features/cart/cart-import-export-feature.module';
import { QuickOrderFeatureModule } from './features/cart/cart-quick-order-feature.module';
import { SavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module';
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module';
import { CustomerTicketingFeatureModule } from './features/customer-ticketing/customer-ticketing-feature.module';
import { OrdersFeatureModule } from './features/order/order-feature.module';
import { OrganizationAdministrationFeatureModule } from './features/organization/organization-administration-feature.module';
import { ProductFeatureModule } from './features/product/product-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { UserFeatureModule } from './features/user/user-feature.module';
import { AtgFeaturesModuleModule } from '../atg/atg-features-module.module';
import { AtgProductFeatureSpecsFeatureModule } from './features/atg-product-feature-specs/atg-product-feature-specs-feature.module';
@NgModule({
  imports: [
    // Auth Core
    AuthModule.forRoot(),

    // Basic Cms Components
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,

    // User
    UserFeatureModule,
    KnBrUserAccountModule,
    KnBrUserProfileModule,
    UserModule,
    UserOccModule,
    UserComponentModule,

    // Anonymous Consents
    AnonymousConsentsModule.forRoot(),
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,

    // Product
    ProductFeatureModule,
    ProductModule.forRoot(),
    ProductOccModule,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    KnBrProductOccModule,
    AtgProductFeatureSpecsFeatureModule,
    // Cart
    CartBaseFeatureModule,
    SavedCartFeatureModule,
    ImportExportFeatureModule,
    WishListModule,

    // Checkout
    CostCenterOccModule,
    CheckoutFeatureModule,

    // Order
    OrdersFeatureModule,
    KnBrOrderOccModule,
    VideoModule,
    PDFModule,

    // SmartEdit
    SmartEditModule,
    SmartEditFeatureModule,

    // Personalization
    PersonalizationModule,

    // // Asm Core
    AsmFeatureModule,
    AsmOccModule,
    AsmComponentsModule,

    // Page Events
    CartPageEventModule,
    ProductPageEventModule,
    NavigationEventModule,

    // Customer ticket support
    CustomerTicketingFeatureModule,

    // Organization
    OrganizationAdministrationFeatureModule,

    /************************* Opt-in features *************************/

    ExternalRoutesModule.forRoot(), // to opt-in explicitly, added by default schematics
    JsonLdBuilderModule,

    /************************* ATG features *************************/
    AtgFeaturesModuleModule,

    /************************* External features *************************/

    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production, connectInZone: true }),
    KnBrCommonModule,
    KnBrCustomerLibsModule,
    KnBrFeaturesLibsModule,
    // Registered after KnBrFeaturesLibsModule so our custom '/quick-order' route
    // (with KnBrCustomerContextGuard) wins over the OOTB Spartacus quickOrder route.
    QuickOrderFeatureModule,
    KnBrStoreModule,

    ConfigModule.withConfig({
      pagination: {
        addPrevious: true,
        addNext: true,
        addDots: true,
      },
    }),
  ],
  providers: [
    provideFeatureToggles({
      authorizationCodeFlowByDefault: true,
      incrementProcessesCountForMergeCart: true,
      dispatchLoginActionOnlyWhenTokenReceived: true,
      cdsLoginEventsToken: true,
    }),
    provideConfig({
      authentication: {
        client_id: 'mobile_android_public',
        client_secret: environment.clientSecret,
        OAuthLibConfig: {
          redirectUri: environment.redirectUri,
        },
        useClientTokens: true
      },
    }),
  ]
})

export class SpartacusFeaturesModule { }
